
	import { Component, Vue } from 'vue-property-decorator';
	import Loading from '@/components/Loading.vue';
	import Fitstation3DScan from '@/components/Fitstation3DScan/Fitstation3DScan.vue';
	import InfoModal from '@/components/InfoModal.vue';
	import { log } from 'three';
	import { Observer } from 'mobx-vue';
	import { observe, reaction } from 'mobx';

	@Observer
	@Component({
		components: { Fitstation3DScan, Loading, InfoModal }
	})
	export default class App extends Vue {
		private classes = {};
		private leftScanLoaded = true;
		private rightScanLoaded = true;
		private bothScanLoaded = false;
		private fullname = '';
		private id = '';
		private showPhotos = false;
		private scanDate;
		private delayPassed = false;
		private hideLoading = true;
		private showDate = false;
		private backPressed = false;
		private needsReload = false;
		private scanNotFound = false;

		public async mounted(): Promise<void> {
			reaction(
				() => this.$state.biometric.bothScansExist,
				(both) => {
					if (both) {
						this.scanNotFound = false;
						this.needsReload = true;
						// this.hideLoading = true;
					}
				}
			);

			window.addEventListener('message', (e) => {
				if (e.data === 'biometric.scansCleared') {
					this.needsReload = true;
					this.hideLoading = true;
				}
			});
			await this.initialize();
		}

		async activated() {
			if (this.needsReload) {
				this.hideLoading = true;
				this.needsReload = false;
				await this.initialize();
			}
			await this.$state.leroy.SetScene('LandmarkSelection');
		}

		async initialize() {
			this.backPressed = false;
			const patient = this.$state._patient;
			const scans = await this.$state.biometric.getLatestScans();
			const timestamp = scans.left.properties?.timestamp || scans.right.properties?.timestamp;
			const operator = scans.left.scan?.operator || scans.right.scan?.operator;
			if (timestamp) {
				this.scanDate = new Date(timestamp);
			}
			const user = await this.$engine.profile.getUser(operator || '');
			this.fullname = `${user?.firstName} ${user?.lastName}`;
			this.showDate = !!this.scanDate;
			this.delayPassed = false;
			this.hideLoading = true;
			window.addEventListener('leftscanLoaded', (e) => {
				this.leftScanLoaded = true;
			});

			window.addEventListener('rightscanLoaded', (e) => {
				this.rightScanLoaded = true;
			});

			window.addEventListener('bothLoaded', (e) => {
				this.bothScanLoaded = true;
			});

			setTimeout(() => {
				this.delayPassed = true;
				if (this.$state.biometric.bothScansExist) {
					// this.leftScanLoaded = true;
					// this.rightScanLoaded = true;
					// this.bothScanLoaded = true;
				}
			}, 500);

			setTimeout(() => {
				this.hideLoading = false;
			}, 1750);
		}

		public notFound() {
			this.scanNotFound = true;
		}

		public async next() {
			await this.$router.push('order-styles');
			if (!this.leftScanLoaded || !this.rightScanLoaded || !this.bothScanLoaded) {
				this.needsReload = true;
				this.hideLoading = true;
			}
		}

		public async prev() {
			this.backPressed = true;
			this.$router.push('landmarks');

			if (!this.leftScanLoaded || !this.rightScanLoaded || !this.bothScanLoaded) {
				this.needsReload = true;
				this.hideLoading = true;
			}

			this.backPressed = false;
		}

		openLandmarks() {
			this.$router.push('landmarks');
		}

		public showBottomPhotos() {
			this.showPhotos = !this.showPhotos;
		}

		private diagonalStripesLeft() {
			if (this.leftScanLoaded) {
				// @ts-ignore
				return this.classes.diagonalStripes;
			}
		}

		private diagonalStripesRight() {
			if (this.rightScanLoaded) {
				// @ts-ignore
				return this.classes.diagonalStripes;
			}
		}
	}
